import axios from "axios";
import { apiKey } from "../config/config";
import React, { useEffect, useState } from "react";
import Table from "../components/Table";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Expenses({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;

  const [expenseList, setExpenseList] = useState([]);
  const [expenseCategories, setExpenseCategories] = useState([]);
  const [accountList, setAccountList] = useState([]);

  // ✅ controlled form states
  const [selectedAccountId, setSelectedAccountId] = useState("");
  const [expense, setExpense] = useState(""); // expense_category id
  const [amount, setAmount] = useState("");
  const [statement, setStatement] = useState("");

  const [expenseCategory, setExpenseCategory] = useState("");
  const [expensesToDelete, setExpensesToDelete] = useState(null);
  const [branchId, setBranchId] = useState();

  useEffect(() => {
    setBranchId(JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).branch_id);
  }, []);

  const fetchAll = async () => {
    if (!branchId) return;

    try {
      const [expRes, catRes, accRes] = await Promise.all([
        axios.get(apiKey + "/get-expenses", {
          params: { branch_id: branchId },
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(apiKey + "/get-expense-category", {
          params: { branch_id: branchId },
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(apiKey + "/get-accounts", {
          params: { branch_id: branchId },
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      setExpenseList(expRes.data.result || []);
      setExpenseCategories(catRes.data.result || []);
      setAccountList(accRes.data.result || []);
    } catch (err) {
      console.error(err);
      toast.error("Error loading data");
    }
  };

  useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchId, token]);

  const handleSubmit = async () => {
    // ✅ validations
    if (!selectedAccountId) return toast.error("Please select account");
    if (!expense) return toast.error("Please select expense category");
    if (!amount || Number(amount) <= 0) return toast.error("Enter valid amount");

    try {
      const payload = {
        expense_category: expense,
        account: Number(selectedAccountId),
        amount: Number(amount),
        statement: statement || null,
        branch_id: branchId,
      };

      const res = await axios.post(apiKey + "/add-expense", payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success(res.data.Message || "Expense added");
      // ✅ reset controlled fields
      setExpense("");
      setSelectedAccountId("");
      setAmount("");
      setStatement("");

      fetchAll();
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.Error || "Some error occured");
    }
  };

  const handleExpenseCatSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        apiKey + "/add-expense-category",
        { expense: expenseCategory, branch_id: branchId },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success(res.data.Message || "Category added");
      setExpenseCategory("");
      fetchAll();
    } catch (err) {
      console.error(err);
      toast.error("Some error occured");
    }
  };

  const returnTable = (table) => {
    setExpensesToDelete(table.map((item) => item.original.id));
  };

  // ✅ delete selected expenses (FIXED axios.delete usage)
  useEffect(() => {
    if (!expensesToDelete?.length) return;

    axios
      .delete(apiKey + "/delete-expense", {
        data: { idList: expensesToDelete },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => fetchAll())
      .catch((err) => console.error(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expensesToDelete, token]);

  const columns = [
    { header: "SN", cell: (row) => row.row.index + 1 },
    { header: lang.Expense_Category || "Expense Category", accessorKey: "expense" },
    { header: lang.Amount || "Amount", accessorKey: "amount" },
    { header: lang.Note || "Note", accessorKey: "statement" },
  ];

  return (
    <div>
      <main className="main" id="main">
        <ToastContainer position="bottom-right" autoClose={5000} theme="colored" />

        <div className="pagetitle">
          <h1>{lang.General_Management || "General Management"}</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                  <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
                </svg>
              </li>
              <li className="breadcrumb-item">{lang.General_Management || "General Management"}</li>
              <li className="breadcrumb-item active">{lang.Expense_List || "Expense List"}</li>
            </ol>
          </nav>
        </div>

        {/* LIST */}
        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="row pt-3">
                  <div className="rr col-9">{lang.Expenses_List || "Expenses List"}</div>
                </div>
                <div className="card-body">
                  <div classNames="d-flex mt-3 mb-3">
                    <Table
                      lang={lang}
                      data={expenseList}
                      columns={columns}
                      returnTable={returnTable}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ADD */}
        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex mt-3 mb-3">
                    <h4 className="headingh4 fw-bold">{lang.Add_Expense || "Add Expense"}</h4>
                  </div>

                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSubmit();
                    }}
                  >
                    <div className="d-flex mt-3 mb-3 justify-content-end">
                      <button type="submit" className="btn-save">
                        {lang.Save_And_Publish || "Save & Publish"}
                      </button>
                      <button
                        type="button"
                        className="btn-cancel ms-4"
                        data-bs-toggle="modal"
                        data-bs-target="#goodsverticalycenteredexpense"
                      >
                        {lang.Add_Category || "Add Category"}
                      </button>
                    </div>

                    {/* Account */}
                    <div className="row mb-3 d-flex justify-content-center">
                      <div className="col-lg-4">
                        <label htmlFor="account" className="w-100">
                          <span style={{ fontSize: "14px" }}>{lang.Account || "Account"}:</span>
                          <select
                            id="account"
                            className="form-select"
                            required
                            value={selectedAccountId}
                            onChange={(e) => setSelectedAccountId(e.target.value)}
                          >
                            <option value="" disabled>
                              {lang.Account || "Account"}
                            </option>
                            {accountList.map((account) => (
                              <option key={account.id} value={account.id}>
                                {account.account_name}
                              </option>
                            ))}
                          </select>
                        </label>
                      </div>
                    </div>

                    {/* Expense Category */}
                    <div className="row mb-3 d-flex justify-content-center">
                      <div className="col-lg-4">
                        <label htmlFor="expenseCategorySelect" className="w-100">
                          <span style={{ fontSize: "14px" }}>
                            {lang.Expense_Category || "Expense Category"}:
                          </span>
                          <select
                            id="expenseCategorySelect"
                            className="form-select"
                            required
                            value={expense}
                            onChange={(e) => setExpense(e.target.value)}
                          >
                            <option value="">
                              {lang.Expense_Category || "Expense Category"}
                            </option>
                            {expenseCategories.map((ex) => (
                              <option key={ex.id} value={ex.id}>
                                {ex.expense}
                              </option>
                            ))}
                          </select>
                        </label>
                      </div>
                    </div>

                    {/* Amount */}
                    <div className="row mb-3 d-flex justify-content-center">
                      <div className="col-lg-4">
                        <label htmlFor="amount" className="w-100">
                          <span style={{ fontSize: "14px" }}>{lang.Amount || "Amount"}:</span>
                          <input
                            type="number"
                            min="0"
                            step="0.01"
                            id="amount"
                            className="form-control"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            required
                          />
                        </label>

                        {/* Optional balance preview */}
                        {/* {selectedAccountId && (
                          <div className="mt-2 small text-muted">
                            Balance Before: {balanceBefore} | Balance After: {balanceAfter}
                          </div>
                        )} */}
                      </div>
                    </div>

                    {/* Statement */}
                    <div className="row mb-3 d-flex justify-content-center">
                      <div className="col-lg-4">
                        <label htmlFor="statement" className="w-100">
                          <span style={{ fontSize: "14px" }}>
                            {lang.Statement_Optional || "Statement (Optional)"}:
                          </span>
                          <textarea
                            id="statement"
                            className="form-control"
                            placeholder="(Optional)"
                            rows={5}
                            value={statement}
                            onChange={(e) => setStatement(e.target.value)}
                          />
                        </label>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* MODAL */}
        <div className="modal fade" id="goodsverticalycenteredexpense" tabIndex={-1}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <form onSubmit={handleExpenseCatSubmit}>
                  <div className="row mb-3 mt-5 d-flex justify-content-center">
                    <div className="col-sm-8 mb-3">
                      <label htmlFor="expenseCategory" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Expense_Category || "Expense Category"}:
                        </span>
                        <input
                          id="expenseCategory"
                          type="text"
                          className="form-control"
                          placeholder="Expense Category"
                          value={expenseCategory}
                          onChange={(e) => setExpenseCategory(e.target.value)}
                          required
                        />
                      </label>
                    </div>
                  </div>

                  <div className="text-center mb-5">
                    <button type="button" className="btn-save" data-bs-dismiss="modal">
                      {lang.Cancel || "Cancel"}
                    </button>
                    <button type="submit" className="btn-cancel">
                      {lang.Add_Now || "Add Now"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Expenses;
